<template>
  <div
    id="app"
    style="background-color: #fafafa; height: 100vh; overflow:hidden;"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
.selected {
  color: $main;
}
</style>



// WEBPACK FOOTER //
// src/App.vue